<article class="container section-inset-y">
  <header class="cart__header mb-4 topbar-padding-top">
    <h2 class="h1">{{ prefix + '-titel' | fromDictionary }}</h2>
  </header>

  @if (!cart$()?.lines?.length) {
    <div class="cart__empty-state p-2 py-5 p-md-5">
      <app-icon class="icon-shopping-cart mb-2" anchor="icon-shopping-cart"></app-icon>
      <h3 class="h4 mb-4">{{ prefix + '-empty-state-tekst' | fromDictionary }}</h3>
      <div>
        @if ((isSignedIn$ | async) === false) {
          <a [routerLink]="['/auth/inloggen']" [queryParams]="{ returnUrl: '/cart' }" class="button button-outline button--secondary">
            {{ 'inloggen-knoptekst' | fromDictionary }}
          </a>
        }
        <a [routerLink]="['/']" class="button button--secondary ms-2">{{ 'verder-winkelen-knoptekst' | fromDictionary }}</a>
      </div>
    </div>
  }

  <main class="">
    @if (cartErrors$(); as errors) {
      @if (errors.length) {
        <div class="row">
          <div class="col-12 col-md-8 my-4">
            @if (errors.length) {
              <app-alert [errors]="errors" [shopifyCodePrefix]="'CartErrorCode'" [status]="'type--danger'"></app-alert>
            }
          </div>
        </div>
      }
    }

    @if (cart$(); as cart) {
      <div class="row">
        @if (cart?.lines?.length) {
          <div class="col-12 col-md-8 mb-4">
            @if (cartLinesLoading$(); as linesLoading) {
              <ul class="cart-overview-list">
                @for (line of cart.lines; track line.id) {
                  <li class="cart-overview-list__item py-4">
                    <app-cart-product-line
                      [cookiePrefs]="cookiePrefs$()"
                      [line]="line"
                      [cartLoading]="cartLoading$()"
                      [linesLoading]="cartLinesLoading$()"
                    ></app-cart-product-line>
                  </li>
                }
                <li>
                  <mat-form-field class="example-full-width mt-3">
                    <mat-label>{{ 'winkelwagen-notitie-label' | fromDictionary }}</mat-label>
                    <textarea
                      class="lh-base"
                      matInput
                      name="cart-note"
                      [formControl]="noteField"
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="10"
                    ></textarea>
                  </mat-form-field>
                </li>
              </ul>
            }
          </div>
        }
        <!-- ORDER SUMMARY -->
        @if (cart && cart?.lines?.length) {
          <aside (fstrInViewport)="inViewChange($event)" [once]="false" [threshold]="0.7" class="col-md-4 col-xl-3 offset-xl-1 py-3">
            <app-cart-summary
              [cart]="cart"
              [cartLoading]="cartLoading$()"
              [customer]="customer$()"
              [hasVatNumber]="!!customerHasVat$()"
              [customerLoaded]="customerLoaded$()"
              [exemptionsChecked]="exemptionsChecked$()"
              [exemptionsChecking]="exemptionsChecking$()"
              [exemptionsValid]="exemptionsValid$()"
            >
              <app-discount-form
                [collapsed]="initDiscountPanelOpen"
                [discountCodes]="cart.discountCodes"
                [discountLoading]="discountLoading$()"
                [discountLoaded]="discountLoaded$()"
              ></app-discount-form>
            </app-cart-summary>
          </aside>
        }
        <!-- Sticky summary -->
        <div [class.is--sticky]="!inviewPort" class="cart-sticky d-block d-md-none p-3" #stickycart>
          <div class="cart-sticky__inner mb-3">
            <dt>
              {{ prefix + '-betaal-overzicht-totaal-incl' | fromDictionary }}
              <span class="ps-1 type-body-xs">{{ prefix + '-betaal-overzicht-totaal-incl-suffix' | fromDictionary }}</span>
            </dt>
            <dd>
              @if (cartLoading$()) {
                <app-icon class="anim--spinning" anchor="icon-loader"></app-icon>
              }
              @if (!cartLoading$()) {
                <em class="cart-sticky__price text-end">
                  {{ cart.cost.totalAmount.amount | currency: cart.cost.totalAmount.currencyCode }}
                </em>
              }
            </dd>
          </div>
          @if (exemptionsChecked$() && !exemptionsValid$()) {
            <app-tax-exemption-alert (proceed)="checkout(true)"></app-tax-exemption-alert>
          }
          <button
            (click)="checkout()"
            class="button button--secondary w-100"
            [disabled]="cartLoading$() || exemptionsChecking$() || (exemptionsChecked$() && !exemptionsValid$())"
          >
            <span>{{ prefix + '-betaal-overzicht-sticky-mobiele-knoptekst' | fromDictionary }}</span>
          </button>
        </div>
        <div>
          <button class="button button-outline button--primary w-100 w-md-auto" (click)="goBack()">
            {{ 'winkelwagen-verder-winkelen-knoptekst' | fromDictionary }}
          </button>
        </div>
      </div>
    }
  </main>
</article>
